import { createRouter, createWebHistory } from 'vue-router'
import Auth from '../views/Auth/Auth.vue'
import Login from '../views/Auth/Login.vue'
import SignUp from '../views/Auth/SignUp.vue'
import ResendConfirmationEmail from '../views/Auth/ResendConfirmationEmail.vue'
import EmailConfirmationInProgress from '../views/Auth/EmailConfirmationInProgress.vue'
import ForgotPassword from '../views/Auth/ForgotPassword.vue'
import ForgotPasswordRequestInProgress from '../views/Auth/ForgotPasswordRequestInProgress.vue'
import ResetPassword from '../views/Auth/ResetPassword.vue'
import Dashboard from '../views/Dashboard/Dashboard.vue'
import DashboardIndex from '../views/Dashboard/DashboardIndex.vue'
import Tickets from '../views/Dashboard/Travels/Tickets/Tickets.vue'
import Payments from '../views/Dashboard/Travels/Payments/Payments.vue'
import BankCards from '../views/Dashboard/Travels/BankCards/BankCards.vue'
import AddBankCards from '../views/Dashboard/Travels/BankCards/AddBankCards.vue'
import Account from '../views/Dashboard/Account/Account.vue'

import NotFound from '../views/NotFound.vue'

const routes = [
    {
        path: '/',
        name: 'Auth',
        component: Auth,
        meta: {
            auth: false
        },
        children: [
            {
                path: '',
                name: 'Login',
                component: Login,
                meta: {
                    auth: false
                }
            },
            {
                path: '/sign/up',
                name: 'SignUp',
                component: SignUp,
                meta: {
                    auth: false
                }
            },
            {
                path: '/resend_confirmation_email',
                name: 'ResendConfirmationEmail',
                component: ResendConfirmationEmail,
                meta: {
                    auth: false
                }
            },
            {
                path: '/email/confirmation_in_progress',
                name: 'EmailConfirmationInProgress',
                component: EmailConfirmationInProgress,
                meta: {
                    auth: false
                }
            },
            {
                path: '/forgot_password',
                name: 'ForgotPassword',
                component: ForgotPassword,
                meta: {
                    auth: false
                }
            },
            {
                path: '/forgot_password/request_in_progress',
                name: 'ForgotPasswordRequestInProgress',
                component: ForgotPasswordRequestInProgress,
                meta: {
                    auth: false
                }
            },
            {
                path: '/reset_password',
                name: 'ResetPassword',
                component: ResetPassword,
                meta: {
                    auth: false
                }
            }
        ]
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
            auth: true
        },
        children: [
            {
                path: '',
                name: 'DashboardIndex',
                component: DashboardIndex,
                meta: {
                    auth: true
                }
            },
            {
                path: '/dashboard/travels/tickets',
                name: 'Tickets',
                component: Tickets,
                meta: {
                    auth: true
                }
            },
            {
                path: '/dashboard/travels/payments',
                name: 'Payments',
                component: Payments,
                meta: {
                    auth: true
                }
            },
            {
                path: '/dashboard/travels/bank_cards',
                name: 'BankCards',
                component: BankCards,
                meta: {
                    auth: true
                }
            },
            {
                path: '/dashboard/travels/bank_cards/add',
                name: 'AddBankCards',
                component: AddBankCards,
                meta: {
                    auth: true
                }
            },
            {
                path: '/dashboard/account',
                name: 'Account',
                component: Account,
                meta: {
                    auth: true
                }
            }
        ]
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: NotFound
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })

    if ('auth' in to.meta && to.meta.auth && localStorage.getItem('session_account') == null) {
        return next({
            path: '/'
        })
    } else if ('auth' in to.meta && !to.meta.auth && localStorage.getItem('session_account')) {
        return next({
            path: '/dashboard'
        })
    } else {
        return next()
    }
})
export default router